var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 600,
    viewBox: "0 0 540 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.667 0C313.869 0 356.262 17.5595 387.518 48.8155C418.774 80.0716 436.333 122.464 436.333 166.667V233.5C462 234 477.867 235.833 490.833 242.433C506.504 250.421 519.245 263.163 527.233 278.833C536.333 296.667 536.333 320 536.333 366.667V466.667C536.333 513.333 536.333 536.667 527.233 554.5C519.245 570.171 506.504 582.912 490.833 590.9C473 600 449.667 600 403 600H136.333C89.6667 600 66.3333 600 48.5 590.9C32.8169 582.918 20.0632 570.176 12.0667 554.5C2.99999 536.667 3 513.333 3 466.667V366.667C3 320 2.99999 296.667 12.0667 278.833C20.0632 263.157 32.8169 250.415 48.5 242.433C61.4667 235.8 77.3333 234 103 233.5V166.667C103 122.464 120.559 80.0716 151.816 48.8155C183.072 17.5595 225.464 0 269.667 0ZM369.667 166.667V233.333H169.667V166.667C169.667 140.145 180.202 114.71 198.956 95.956C217.71 77.2024 243.145 66.6667 269.667 66.6667C296.188 66.6667 321.624 77.2024 340.377 95.956C359.131 114.71 369.667 140.145 369.667 166.667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLocked);
export default __webpack_public_path__ + "static/media/ico_locked.ad6d1d5351aa227f114fbbb85de7e1aa.svg";
export { ForwardRef as ReactComponent };